import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Autocomplete,
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useFormik, getIn } from "formik";
import * as Yup from "yup";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Colors from "../../theme/colors.json";
import { useDispatch, useSelector } from "react-redux";
import DocumentUpload from "./DocumentUpload";
import CONSTANTS, {
  Btn_Action,
  COMMISSION_STATUS_LIST,
  CONFIRMATION_CONTENT,
  CONFIRMATION_TITLE,
  DECISION_ENUMS,
  DECISION_MENUITEMS,
  GET_RECORDS_LIMIT,
  Gross_Premium_Multiplier,
  INSURANCE_COMPANIES_FORM_ID,
  PREVIEW_PLACEMENT_ENUMS,
  PROPOSAL_STATUS,
  REWARD_STATUS_LIST,
  USER_GROUPS,
} from "../../constants/constants";
import {
  POLICY_DOCUMENT_DETAILS_CONSTANTS,
  PRE_POLICYPLACEMENT_CONSTANTS,
} from "./FormConstants";
import BrokingCompanyDetails from "./BrokingCompanyDetails";
import PremiumBreakUp from "./PremiumBreakUp";
import InsuranceCompanyDetails from "./InsuranceCompanyDetails";
import {
  fetchRuntimeFormData,
  filterRuntimeFormDataWithId,
  patchFormData,
} from "../../services/FormService";
import { styled, lighten, darken } from "@mui/system";
import { pushNotification, setProposalData } from "../../redux/actions";
import { useNavigate } from "react-router-dom";
import html2pdf from "html2pdf.js";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import PlacementSlipPreview from "./PlacementSlipPreview";
import CommissionInfo from "./CommissionInfo";
import { useReactToPrint } from "react-to-print";
import PlacementLetterPreview from "./PlacementLetterPreview";
import PolicyDocumentDetails from "./PolicyDocumentDetails";
import InstallmentDetails from "./InstallmentDetails";
import Lottie from "lottie-react";
import DataLoader from "../../animations/LoadingCube.json";
import EndorsementPremium from "./EndorsementPremium";
import Fonts from "../../theme/font_size.json";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SaveIcon from "@mui/icons-material/Save";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import EmailReminders from "./EmailReminders";

const useStyles = makeStyles((theme) => ({
  PrePolicyPlacementContainer: {
    width: "100%",
    height: "100%",
  },
  PrePolicyPlacementSection: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    gap: "2vh",
  },

  formFieldFlexColumn: {
    flex: " 0 0 30%",
    display: "flex",
    flexDirection: "column",
    // width: "30%",
    gap: "2.5%",
  },
  formFieldsFlexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    width: "95%",
    rowGap: 15,
    // padding: "0% 2.5% 0% 2.5%",
    justifyContent: "space-between",
    background: Colors.WHITE_BACKGROUND,
    padding: "2.5% 2.5% 2.5% 2.5%",
    borderRadius: "0.6rem",
    fontSize: theme.fontSizes.SMALL,
  },
  PrePolicyPlacementHeadingSection: {
    // backgroundColor: theme.palette.primary.main,
    display: "flex",
    justifyContent: "flex-start",
    width: "95%",
    // marginBottom: "2%",
    borderRadius: "0.5vw",
  },
  PrePolicyPlacementHeading: {
    color: theme.palette.secondary.main,
    fontSize: theme.fontSizes.MEDIUM,
    fontWeight: 600,
  },
  actionsContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    width: "95%",
    position: "sticky",
    bottom: "0",
    marginBottom: "1%",
    padding: "0.6%",
    backgroundColor: Colors.WHITE_BACKGROUND,
    borderRadius: 5,
    "&:hover": {
      backgroundColor: Colors.INSUR_BG,
      borderRadius: 0,
    },
  },
  actionsContainerNo: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "95%",
    padding: "0.6%",
    backgroundColor: Colors.WHITE_BACKGROUND,
    borderRadius: 5,
    "&:hover": {
      backgroundColor: Colors.INSUR_BG,
      borderRadius: 0,
    },
  },
  policyPlacementsDocumentsSection: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    // width: "95%",
    // gap: "3%",
    rowGap: 25,
    padding: "2% 2.5% 2% 2.5%",
    justifyContent: "space-between",
  },
  fileUploader: {
    flex: " 0 0 48%",
    // width: "45%",
  },
  financerField: {
    flex: " 0 0 48%",
    display: "flex",
    flexDirection: "column",
    // width: "45%",
    gap: "2.5%",
  },
  placementContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap",
    width: "100%",
    padding: "0% 2.5% 0% 2.5%",
    gap: "5%",
    rowGap: 25,
  },
  policyDetailsSectionTwoContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flexWrap: "wrap",
    width: "100%",
    padding: "0% 2.5% 0% 2.5%",
    gap: "5%",
    rowGap: 25,
  },
  policyDetailsSectionThreeContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    // flexWrap: "wrap",
    width: "100%",
    padding: "0% 2.5% 0% 2.5%",
    gap: "5%",
    rowGap: 25,
  },
  fieldsMinWidth: {
    minWidth: "18vw",
  },
  customDialog: {
    // zIndex: 10000,
    "& .MuiDialog-paper": {
      maxWidth: "unset",
    },
  },
  policyPlacementDocumentsDiv: {
    // border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: "1vw",
    boxShadow: `inset -2px -2px 4px ${theme.palette.primary.main}50,
    inset 2px 2px 4px ${theme.palette.primary.main}25,
    inset 5px 5px 10px ${theme.palette.primary.main}50,
    inset -5px -5px 10px ${theme.palette.primary.main}50`,
    width: "95%",
  },
  policyDetailsSectionFourContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flexWrap: "wrap",
    width: "100%",
    gap: "5%",
    rowGap: 25,
  },
  policyDetailsSectionFiveContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flexWrap: "wrap",
    width: "100%",
    padding: "0% 2.5% 0% 2.5%",
    gap: "5%",
    rowGap: 25,
  },
  policyLoader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center !important",
    alignItems: "center !important",
  },
  commonBtnStylesPolicy: {
    background: Colors.WHITE_BACKGROUND,
    textTransform: "capitalize",
  },
  fieldFonts: {
    fontSize: theme.fontSizes.SMALL,
  },
  previewDialogHeading: {
    background: Colors.INSUR_BG,
    m: 0,
    padding: "0.4rem",
  },
  autocompleteInputStyle: {
    fontSize: theme.fontSizes.SMALL,
    height: "0.4rem !important",
  },
  selectField: {
    fontSize: theme.fontSizes.SMALL,
    // height: "1.875rem !important",
  },
  textField: {
    fontSize: theme.fontSizes.SMALL,
    // height: "1.875rem !important",
  },
  actionsSubContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "27%",
  },
  btnIconStyle: {
    fontSize: "medium",
  },
  validationAction: {
    pointerEvents: "none",
  },
}));

const Date_Feild_Style = {
  fontSize: Fonts[13],
};

const policyAnimation = {
  height: "60vh",
};

const GroupHeader = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "-8px",
  padding: "4px 10px",
  color: theme.palette.primary.main,
  backgroundColor:
    theme.palette.mode === "light"
      ? lighten(theme.palette.primary.light, 0.85)
      : darken(theme.palette.primary.main, 0.8),
}));

const GroupItems = styled("ul")({
  padding: 0,
});

const PrePolicyPlacement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const { proposalDataRedux } = useSelector((state: any) => ({
    proposalDataRedux: state.proposalData,
  }));
  const { userGroup } = useSelector((state: any) => ({
    userGroup: state.userGroup,
  }));

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const handleYes = () => {
    setConfirmDialogOpen(false);
    setValidation(true);
  };

  const handleNo = () => {
    setConfirmDialogOpen(false);
  };

  const [validation, setValidation] = useState(false);
  const [btnClicked, setBtnClicked] = useState({ action: null, count: 0 });

  const [insuranceProviders, setInsuranceProviders] = useState<any>([]);
  const [nonMaterializationReasonsList, setNonMaterializationReasonsList] =
    useState([
      "Insurer not supported",
      "Client not supported",
      "Premium could not get competitive",
      "Client directly placed with Insurer",
      "Done with existing Intermediatory",
    ]);

  const [paymentModeList, setPaymentModeList] = useState([
    "Online through link sent",
    "NEFT",
    "RTGS",
    "IMPS",
    "Cheque",
    "Auto debit",
    "UPI",
    "From Cash Deposit (CD) Account",
  ]);

  const [brokingCompanyDetails, setBrokingCompanyDetails] = useState<any>({});
  const [insuranceCompanyDetails, setInsuranceCompanyDetails] = useState<any>(
    {}
  );
  const [premiumBreakUpDetails, setPremiumBreakUpDetails] = useState({
    netPremium: { netPremium: 0, gst: 0, gstPremium: 0, premiumWithGst: 0 },
    motorTpPremium: { netPremium: 0, gst: 0, gstPremium: 0, premiumWithGst: 0 },
    totalPremium: {
      totalNetPremium: 0,
      totalGstPremium: 0,
      totalPremiumWithGst: 0,
    },
    grossPremium: { grossPremiumWithGst: 0 },
    validation: false,
  });

  const [commissionDetails, setCommissionDetails] = useState({
    netPremium: {
      netPremium: 0,
      commission: 0,
      commissionAmount: 0,
      reward: 0,
      rewardAmount: 0,
    },
    motorTpPremium: {
      netPremium: 0,
      commission: 0,
      commissionAmount: 0,
      reward: 0,
      rewardAmount: 0,
    },
    totalPremium: {
      totalNetPremium: 0,
      totalCommissionAmount: 0,
      totalRewardAmount: 0,
    },
    commissionStatus: COMMISSION_STATUS_LIST[0]?.value || "",
    rewardStatus: REWARD_STATUS_LIST[0]?.value || "",
    commissionAmountValidation: false,
    rewardAmountValidation: false,
  });

  const [installmentDetails, setInstallmentDetails] = useState({
    netPremium: 0,
    projectPeriod: 0,
    elligibleInstallments: 0,
    validation:
      proposalDataRedux?.formData?.policyManagementAndCustomerCare
        ?.installmentDetails?.validation || false,
    installments: [],
  });

  const [endorsementPremium, setEndorsementPremium] = useState([]);

  const [endorsementCommission, setEndorsementCommission] = useState<any>([]);

  const [activeStep, setActiveStep] = useState(1);
  const [disableDownload, setDisableDownload] = useState(false);
  const [preview, setPreview] = useState("");
  const [isLoading, setIsloading] = useState(false);

  //code for Placement Letter & Slip dialog /
  const [openPreview, setOpenPreview] = React.useState(false);

  const handleClickOpenPreview = () => {
    setOpenPreview(true);
  };
  const handleClosePreview = () => {
    setOpenPreview(false);
  };

  const handlePreviewButtonClick = (value) => {
    setPreview(value);
    handleClickOpenPreview();
  };
  // end

  //code for placment letter & slip generate
  const [generate, setGenerate] = useState("");
  const [openGenerate, setOpenGenerate] = useState(false);

  const handleGenerateButtonClick = (value) => {
    setGenerate(value);
    handleClickOpenGenerate();
  };

  const handleClickOpenGenerate = () => {
    setOpenGenerate(true);
  };
  const handleCloseGenerate = () => {
    setOpenGenerate(false);
  };
  //end

  //code for placement letter preview dialog
  const placementLetterContentRef = useRef(null); // Create a reference to the content container

  const handleDownloadPlacementLetterPDF = () => {
    setDisableDownload(true);
    // const content = placementLetterContentRef.current; // Access the content using the ref

    // // Configuration for html2pdf
    // const opt = {
    //   margin: 10,
    //   filename: `PlacementLetter`,
    //   image: { type: "jpeg", quality: 0.98 },
    //   html2canvas: { scale: 2 },
    //   jsPDF: {
    //     unit: "mm",
    //     format: "a4",
    //     orientation: "landscape",
    //   },
    //   pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    // };

    // // Generate PDF from the content
    // html2pdf().from(content).set(opt).save();
    printPlacementLetterData();
    setDisableDownload(false);
  };
  const printPlacementLetterData = useReactToPrint({
    content: () => placementLetterContentRef.current,
    documentTitle: "PlacementLetter",
  });
  //end

  //code for placement slip preview dialog
  const placementSlipContentRef = useRef(null); // Create a reference to the content container

  const handleDownloadPlacementSlipPDF = () => {
    setDisableDownload(true);
    // const content = placementSlipContentRef.current; // Access the content using the ref

    // // Configuration for html2pdf
    // const opt = {
    //   margin: 10,
    //   filename: `PlacementSlip`,
    //   image: { type: "jpeg", quality: 0.98 },
    //   html2canvas: { scale: 2 },
    //   jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
    //   pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    // };

    // // Generate PDF from the content
    // html2pdf().from(content).set(opt).save();
    printPlacementSlipData();
    setDisableDownload(false);
  };
  const printPlacementSlipData = useReactToPrint({
    content: () => placementSlipContentRef.current,
    documentTitle: "PlacementSlip",
  });

  const handlePreviewDownload = () => {
    if (preview === PREVIEW_PLACEMENT_ENUMS.PREVIEW_PLACEMENT_LETTER) {
      handleDownloadPlacementLetterPDF();
    } else {
      handleDownloadPlacementSlipPDF();
    }
  };
  //end

  // code for Policy Document Details

  const formPolicyDocumentDetails = useFormik({
    initialValues: {
      policyNumber: "",
      isPolicyThroughlyReviewed: "",
      policyDocument: {
        fileName: "",
        fileType: "",
        fileSize: "",
        documentId: "",
        status: "",
      },
      finalRfq: {
        fileName: "",
        fileType: "",
        fileSize: "",
        documentId: "",
        status: "",
      },
      finalQcr: {
        fileName: "",
        fileType: "",
        fileSize: "",
        documentId: "",
        status: "",
      },
      mandateCopy: {
        fileName: "",
        fileType: "",
        fileSize: "",
        documentId: "",
        status: "",
      },
      isPolicyPremiumIsPaidInInstallments: "",
      // isC52IdYes: "",
      validation: false,
    },
    validationSchema: Yup.object().shape({
      policyNumber: Yup.string().required(
        POLICY_DOCUMENT_DETAILS_CONSTANTS.policyNumber
      ),
      isPolicyThroughlyReviewed: Yup.string().required(
        POLICY_DOCUMENT_DETAILS_CONSTANTS.isPolicyThroughlyReviewed
      ),

      // policyDocument: Yup.object({
      //   fileName: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.policyDocument
      //   ),
      //   fileType: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.policyDocument
      //   ),
      //   fileSize: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.policyDocument
      //   ),
      //   documentId: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.policyDocument
      //   ),
      //   status: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.policyDocument
      //   ),
      // }),
      // finalRfq: Yup.object({
      //   fileName: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.finalRfq
      //   ),
      //   fileType: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.finalRfq
      //   ),
      //   fileSize: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.finalRfq
      //   ),
      //   documentId: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.finalRfq
      //   ),
      //   status: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.finalRfq
      //   ),
      // }),

      // finalQcr: Yup.object({
      //   fileName: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.finalQcr
      //   ),
      //   fileType: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.finalQcr
      //   ),
      //   fileSize: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.finalQcr
      //   ),
      //   documentId: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.finalQcr
      //   ),
      //   status: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.finalQcr
      //   ),
      // }),
      // mandateCopy: Yup.object({
      //   fileName: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.mandateCopy
      //   ),
      //   fileType: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.mandateCopy
      //   ),
      //   fileSize: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.mandateCopy
      //   ),
      //   documentId: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.mandateCopy
      //   ),
      //   status: Yup.string().required(
      //     POLICY_DOCUMENT_DETAILS_CONSTANTS.mandateCopy
      //   ),
      // }),
      isPolicyPremiumIsPaidInInstallments: Yup.string().required(
        POLICY_DOCUMENT_DETAILS_CONSTANTS.isPolicyPremiumIsPaidInInstallments
      ),
      // isC52IdYes: Yup.string().required(
      //   POLICY_DOCUMENT_DETAILS_CONSTANTS.isC52IdYes
      // ),
    }),

    onSubmit: (values, { setSubmitting }) => {
      handleSubmitPolicyDocumentDetails(values, setSubmitting);
    },
    enableReinitialize: true,
  });

  const handleSubmitPolicyDocumentDetails = async (values, setSubmitting) => {
    setSubmitting(true);
    setIsloading(true);
    let body = {
      formId: proposalDataRedux?.formId,
      id: proposalDataRedux?.id,
      formData: {
        policyManagementAndCustomerCare: {
          ...proposalDataRedux?.formData?.policyManagementAndCustomerCare,
          policyDocumentDetails: {
            policyNumber: values?.policyNumber,
            isPolicyThroughlyReviewed: values?.isPolicyThroughlyReviewed,
            policyDocument: values?.policyDocument,
            finalRfq: values?.finalRfq,
            finalQcr: values?.finalQcr,
            mandateCopy: values?.mandateCopy,
            isPolicyPremiumIsPaidInInstallments:
              values?.isPolicyPremiumIsPaidInInstallments,
            // isC52IdYes: values?.isC52IdYes,
            validation: values?.validation,
          },
        },
      },
    };
    const response = await patchFormData(body);
    if (response?.success) {
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );

      dispatch(
        setProposalData({
          id: response?.data?.id,
          formId: body?.formId,
          formData: {
            ...proposalDataRedux?.formData,
            policyManagementAndCustomerCare: {
              ...proposalDataRedux?.formData?.policyManagementAndCustomerCare,
              policyDocumentDetails:
                body?.formData?.policyManagementAndCustomerCare
                  ?.policyDocumentDetails,
            },
          },
        })
      );
      setIsloading(false);
      // body?.formData?.policyManagementAndCustomerCare?.policyDocumentDetails
      //   ?.isPolicyPremiumIsPaidInInstallments === DECISION_ENUMS.YES && activeStep === 4
      //   ? handleNextStep()
      //   : navigate(`${process.env.PUBLIC_URL}/proposalList`);
      handleNextStep();
    } else {
      pushNotification({
        isOpen: true,
        type: CONSTANTS.ERROR,
        message: response?.message,
      });
      setIsloading(false);
    }
  };

  //end for Policy Document Details

  const formOne = useFormik({
    initialValues: {
      isPolicyPlacementDoneWithTrovity: "",
      whoIsTheIntermediary: "",
      reasonForTheNonMaterializationOfTheProposal: "",
      policyStartDate: null,
      policyEndDate: null,
      leadInsurer: "",
      insurerBranch: "",
      netPremiumPaid: null,
      grossPremium: null,
      paymentMode: "",
      paymentReferenceNumber: "",
      paymentDate: null,
      financierName: "",
      gstNumber: "",
      // panDetails: {
      //   fileName: "",
      //   fileType: "",
      //   fileSize: "",
      //   documentId: "",
      //   status: "",
      // },
      // aadhaarDetails: {
      //   fileName: "",
      //   fileType: "",
      //   fileSize: "",
      //   documentId: "",
      //   status: "",
      // },
      // gstCertificate: {
      //   fileName: "",
      //   fileType: "",
      //   fileSize: "",
      //   documentId: "",
      //   status: "",
      // },
    },
    validationSchema: Yup.object().shape({
      isPolicyPlacementDoneWithTrovity: Yup.string().required(
        PRE_POLICYPLACEMENT_CONSTANTS.isPolicyPlacementDoneWithTrovity
      ),
      whoIsTheIntermediary: Yup.string().when(
        "isPolicyPlacementDoneWithTrovity",
        {
          is: DECISION_ENUMS.NO,
          then: (schema) =>
            schema.required(PRE_POLICYPLACEMENT_CONSTANTS.whoIsTheIntermediary),
        }
      ),

      reasonForTheNonMaterializationOfTheProposal: Yup.string().when(
        "isPolicyPlacementDoneWithTrovity",
        {
          is: DECISION_ENUMS.NO,
          then: (schema) =>
            schema.required(
              PRE_POLICYPLACEMENT_CONSTANTS.reasonForTheNonMaterializationOfTheProposal
            ),
        }
      ),
      policyStartDate: Yup.string().when("isPolicyPlacementDoneWithTrovity", {
        is: DECISION_ENUMS.YES,
        then: (schema) =>
          schema.required(PRE_POLICYPLACEMENT_CONSTANTS.policyStartDate),
        otherwise: (schema) => schema.nullable(),
      }),

      // policyEndDate: Yup.string().when("isPolicyPlacementDoneWithTrovity", {
      //   is: DECISION_ENUMS.YES,
      //   then: (schema) =>
      //     schema.required(PRE_POLICYPLACEMENT_CONSTANTS.policyEndDate),
      //   otherwise: (schema) => schema.nullable(),
      // }),
      policyEndDate: Yup.string().required(PRE_POLICYPLACEMENT_CONSTANTS.policyEndDate),
      leadInsurer: Yup.string().required(
        PRE_POLICYPLACEMENT_CONSTANTS.leadInsurer
      ),
      insurerBranch: Yup.string().required(
        PRE_POLICYPLACEMENT_CONSTANTS.insurerBranch
      ),
      netPremiumPaid: Yup.string()
        .when("isPolicyPlacementDoneWithTrovity", {
          is: DECISION_ENUMS.YES,
          then: (schema) =>
            schema.required(PRE_POLICYPLACEMENT_CONSTANTS.netPremiumPaid),
        })
        .nullable(),

      grossPremium: Yup.string()
        .when("isPolicyPlacementDoneWithTrovity", {
          is: DECISION_ENUMS.YES,
          then: (schema) =>
            schema.required(PRE_POLICYPLACEMENT_CONSTANTS.grossPremium),
        })
        .nullable(),

      // paymentMode: Yup.string().when("isPolicyPlacementDoneWithTrovity", {
      //   is: DECISION_ENUMS.YES,
      //   then: (schema) =>
      //     schema.required(PRE_POLICYPLACEMENT_CONSTANTS.paymentMode),
      // }),
      // paymentReferenceNumber: Yup.string().when(
      //   "isPolicyPlacementDoneWithTrovity",
      //   {
      //     is: DECISION_ENUMS.YES,
      //     then: (schema) =>
      //       schema.required(
      //         PRE_POLICYPLACEMENT_CONSTANTS.paymentReferenceNumber
      //       ),
      //   }
      // ),
      // paymentDate: Yup.string().when("isPolicyPlacementDoneWithTrovity", {
      //   is: DECISION_ENUMS.YES,
      //   then: (schema) =>
      //     schema.required(PRE_POLICYPLACEMENT_CONSTANTS.paymentDate),
      //   otherwise: (schema) => schema.nullable(),
      // }),
      // financierName: Yup.string().when("isPolicyPlacementDoneWithTrovity", {
      //   is: DECISION_ENUMS.YES,
      //   then: (schema) =>
      //     schema.required(PRE_POLICYPLACEMENT_CONSTANTS.financierName),
      // }),
      // panDetails: Yup.object().when("isPolicyPlacementDoneWithTrovity", {
      //   is: DECISION_ENUMS.YES,
      //   then: (schema: any) =>
      //     Yup.object({
      //       fileName: Yup.string().required(PRE_POLICYPLACEMENT_CONSTANTS.pan),
      //       fileType: Yup.string().required(PRE_POLICYPLACEMENT_CONSTANTS.pan),
      //       fileSize: Yup.string().required(PRE_POLICYPLACEMENT_CONSTANTS.pan),
      //       documentId: Yup.string().required(
      //         PRE_POLICYPLACEMENT_CONSTANTS.pan
      //       ),
      //       status: Yup.string().required(PRE_POLICYPLACEMENT_CONSTANTS.pan),
      //     }),
      // }),
      // aadhaarDetails: Yup.object().when("isPolicyPlacementDoneWithTrovity", {
      //   is: DECISION_ENUMS.YES,
      //   then: (schema: any) =>
      //     Yup.object({
      //       fileName: Yup.string().required(
      //         PRE_POLICYPLACEMENT_CONSTANTS.aadhar
      //       ),
      //       fileType: Yup.string().required(
      //         PRE_POLICYPLACEMENT_CONSTANTS.aadhar
      //       ),
      //       fileSize: Yup.string().required(
      //         PRE_POLICYPLACEMENT_CONSTANTS.aadhar
      //       ),
      //       documentId: Yup.string().required(
      //         PRE_POLICYPLACEMENT_CONSTANTS.aadhar
      //       ),
      //       status: Yup.string().required(PRE_POLICYPLACEMENT_CONSTANTS.aadhar),
      //     }),
      // }),
      // gstCertificate: Yup.object().when("isPolicyPlacementDoneWithTrovity", {
      //   is: DECISION_ENUMS.YES,
      //   then: (schema: any) =>
      //     Yup.object({
      //       fileName: Yup.string().required(
      //         PRE_POLICYPLACEMENT_CONSTANTS.gstCertificate
      //       ),
      //       fileType: Yup.string().required(
      //         PRE_POLICYPLACEMENT_CONSTANTS.gstCertificate
      //       ),
      //       fileSize: Yup.string().required(
      //         PRE_POLICYPLACEMENT_CONSTANTS.gstCertificate
      //       ),
      //       documentId: Yup.string().required(
      //         PRE_POLICYPLACEMENT_CONSTANTS.gstCertificate
      //       ),
      //       status: Yup.string().required(
      //         PRE_POLICYPLACEMENT_CONSTANTS.gstCertificate
      //       ),
      //     }),
      // }),
    }),

    onSubmit: (values, { setSubmitting }) => {
      handleSubmit(values, setSubmitting);
    },
    enableReinitialize: true,
  });

  const handleSubmit = async (values, setSubmitting) => {
    setIsloading(true);
    handleStepOneSubmission(values, setSubmitting);
  };

  const handleStepOneSubmission = async (values: any, setSubmitting: any) => {
    setSubmitting(false);

    let body = {
      formId: proposalDataRedux?.formId,
      id: proposalDataRedux?.id,
      formData: {
        policyManagementAndCustomerCare: {
          ...proposalDataRedux?.formData?.policyManagementAndCustomerCare,
          prePolicyPlacementData: {
            isPolicyPlacementDoneWithUs:
              values?.isPolicyPlacementDoneWithTrovity,
            whoIsTheIntermediary: values?.whoIsTheIntermediary,
            reasonForTheNonMaterializationOfTheProposal:
              values?.reasonForTheNonMaterializationOfTheProposal,
            policyStartDate: values?.policyStartDate,
            policyEndDate: values?.policyEndDate,
            leadInsurer: values?.leadInsurer,
            insurerBranch: values?.insurerBranch,
            netPremiumPaid: values?.netPremiumPaid,
            grossPremium: values?.grossPremium,
            paymentMode: values?.paymentMode,
            paymentReferenceNumber: values?.paymentReferenceNumber,
            paymentDate: values?.paymentDate,
            financierName: values?.financierName,
            panDetails: values?.panDetails,
            aadhaarDetails: values?.aadhaarDetails,
            gstCertificate: values?.gstCertificate,
            gstNumber: values?.gstNumber,
            validation: validation,
          },
        },
      },
    };
    const response = await patchFormData(body);
    if (response?.success) {
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );

      dispatch(
        setProposalData({
          id: response?.data?.id,
          formId: body?.formId,
          formData: {
            ...proposalDataRedux?.formData,
            ...body?.formData,
          },
        })
      );

      // if (
      //   formOne.values.isPolicyPlacementDoneWithTrovity === DECISION_ENUMS.YES
      // ) {
      handleNextStep();
      // } else {
      //   navigate(`${process.env.PUBLIC_URL}/proposalList`);
      // }
      setIsloading(false);
    } else {
      pushNotification({
        isOpen: true,
        type: CONSTANTS.ERROR,
        message: response?.message,
      });
      setIsloading(false);
    }
  };

  const handleStepTwoSubmission = async () => {
    setIsloading(true);
    let body = {
      formId: proposalDataRedux?.formId,
      id: proposalDataRedux?.id,
      formData: {
        policyManagementAndCustomerCare: {
          ...proposalDataRedux?.formData?.policyManagementAndCustomerCare,
          brokingCompanyDetails: brokingCompanyDetails,
          insuranceCompanyDetails: insuranceCompanyDetails,
        },
      },
    };
    const response = await patchFormData(body);
    if (response?.success) {
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );

      dispatch(
        setProposalData({
          id: response?.data?.id,
          formId: body?.formId,
          formData: {
            ...proposalDataRedux?.formData,
            policyManagementAndCustomerCare: {
              ...proposalDataRedux?.formData?.policyManagementAndCustomerCare,
              brokingCompanyDetails: brokingCompanyDetails,
              insuranceCompanyDetails: insuranceCompanyDetails,
            },
          },
        })
      );
      handleNextStep();
      setIsloading(false);
    } else {
      pushNotification({
        isOpen: true,
        type: CONSTANTS.ERROR,
        message: response?.message,
      });
      setIsloading(false);
    }
  };

  //Step Three

  const handleStepThreeSubmission = async () => {
    setIsloading(true);
    let body = {
      formId: proposalDataRedux?.formId,
      id: proposalDataRedux?.id,
      formData: {
        policyManagementAndCustomerCare: {
          ...proposalDataRedux?.formData?.policyManagementAndCustomerCare,
          premiumBreakUpDetails: premiumBreakUpDetails,
          commissionInfoDetails: commissionDetails,
          endorsementPremium: endorsementPremium,
          endorsementCommission: endorsementCommission,
        },
      },
    };
    const response = await patchFormData(body);
    if (response?.success) {
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );

      dispatch(
        setProposalData({
          id: response?.data?.id,
          formId: body?.formId,
          formData: {
            ...proposalDataRedux?.formData,
            policyManagementAndCustomerCare: {
              ...proposalDataRedux?.formData?.policyManagementAndCustomerCare,
              premiumBreakUpDetails: premiumBreakUpDetails,
              commissionInfoDetails: commissionDetails,
              endorsementPremium: endorsementPremium,
              endorsementCommission: endorsementCommission,
            },
          },
        })
      );
      handleNextStep();
      setIsloading(false);
    } else {
      pushNotification({
        isOpen: true,
        type: CONSTANTS.ERROR,
        message: response?.message,
      });
      setIsloading(false);
    }
  };

  const emailReminderDetails = useFormik<any>({
    initialValues: {
      renewalReminder: false,
      renewalReminderEmails: [],
      renewalReminderFrequency: [],
      installmentReminder: false,
      installmentReminderEmails: [],
      installmentReminderFrequency: [],
    },
    initialTouched: {
      renewalReminder: true,
      renewalReminderEmails: true,
      renewalReminderFrequency: true,
      installmentReminder: true,
      installmentReminderEmails: true,
      installmentReminderFrequency: true,
    },
    validationSchema: Yup.object({
      renewalReminder: Yup.boolean(),
      renewalReminderEmails: Yup.array().when("renewalReminder", {
        is: true,
        then: (schema) =>
          schema
            .of(
              Yup.string()
                .email("Invalid email address")
                .required("Email is required")
            )
            .min(1, "At least one email is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      renewalReminderFrequency: Yup.array().when("renewalReminder", {
        is: true,
        then: (schema) =>
          schema
            .min(1, "Please select at least one frequency")
            .required("Please select at least one frequency"),
        otherwise: (schema) => schema.notRequired(),
      }),
      installmentReminder: Yup.boolean(),
      installmentReminderEmails: Yup.array().when("installmentReminder", {
        is: true,
        then: (schema) =>
          schema
            .of(
              Yup.string()
                .email("Invalid email address")
                .required("Email is required")
            )
            .min(1, "At least one email is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      installmentReminderFrequency: Yup.array().when("installmentReminder", {
        is: true,
        then: (schema) =>
          schema
            .min(1, "Please select at least one frequency")
            .required("Please select at least one frequency"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values, { setSubmitting }) => {
      handleStepEmailNotification(values, setSubmitting);
    },
  });

  const handleStepEmailNotification = async (
    values: any,
    setSubmitting: any
  ) => {
    setSubmitting(true);
    setIsloading(true);
    let body = {
      formId: proposalDataRedux?.formId,
      id: proposalDataRedux?.id,
      formData: {
        policyManagementAndCustomerCare: {
          ...proposalDataRedux?.formData?.policyManagementAndCustomerCare,
          notificationSettings: {
            renewalReminder: values?.renewalReminder,
            renewalReminderEmails: values?.renewalReminderEmails,
            renewalReminderFrequency: values?.renewalReminderFrequency,
            installmentReminder: values?.installmentReminder,
            installmentReminderEmails: values?.installmentReminderEmails,
            installmentReminderFrequency: values?.installmentReminderFrequency,
          },
        },
      },
    };
    const response = await patchFormData(body);
    if (response?.success) {
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );

      dispatch(
        setProposalData({
          id: response?.data?.id,
          formId: body?.formId,
          formData: {
            ...proposalDataRedux?.formData,
            policyManagementAndCustomerCare: {
              ...proposalDataRedux?.formData?.policyManagementAndCustomerCare,
              notificationSettings:
                body?.formData?.policyManagementAndCustomerCare
                  ?.notificationSettings,
            },
          },
        })
      );
      setIsloading(false);
      // body?.formData?.policyManagementAndCustomerCare?.policyDocumentDetails
      //   ?.isPolicyPremiumIsPaidInInstallments === DECISION_ENUMS.YES
      //   ? handleNextStep()
      //   : navigate(`${process.env.PUBLIC_URL}/proposalList`);
      // if (btnClicked?.action === Btn_Action.NEXT) {
      navigate(`${process.env.PUBLIC_URL}/proposalList`);
      // }
    } else {
      pushNotification({
        isOpen: true,
        type: CONSTANTS.ERROR,
        message: response?.message,
      });
      setIsloading(false);
    }

    // console.log(values, "I'm working vinay 8th wonder");
    // setIsloading(false);
    // handleNextStep(); //should be called based on based on ispolicypremium (yes/no) submit button end icon also
  };

  const handleStepFiveSubmission = async () => {
    setIsloading(true);
    let body = {
      formId: proposalDataRedux?.formId,
      id: proposalDataRedux?.id,
      formData: {
        policyManagementAndCustomerCare: {
          ...proposalDataRedux?.formData?.policyManagementAndCustomerCare,
          installmentDetails: installmentDetails,
        },
      },
    };
    const response = await patchFormData(body);
    if (response?.success) {
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );

      dispatch(
        setProposalData({
          id: response?.data?.id,
          formId: body?.formId,
          formData: {
            ...proposalDataRedux?.formData,
            policyManagementAndCustomerCare: {
              ...proposalDataRedux?.formData?.policyManagementAndCustomerCare,
              installmentDetails: installmentDetails,
            },
          },
        })
      );
      setIsloading(false);
      handleNextStep();
      // if (btnClicked?.action === Btn_Action.NEXT) {
      //   navigate(`${process.env.PUBLIC_URL}/proposalList`);
      // }
    } else {
      pushNotification({
        isOpen: true,
        type: CONSTANTS.ERROR,
        message: response?.message,
      });
      setIsloading(false);
    }
  };

  const handleStepsSubmission = () => {
    const isPolicyPremiumPaidInInstallments =
      formPolicyDocumentDetails?.values?.isPolicyPremiumIsPaidInInstallments;

    const isPolicyPlacementDoneWithTrovity =
      formOne?.values?.isPolicyPlacementDoneWithTrovity;

    switch (activeStep) {
      case 1:
        formOne.handleSubmit();
        break;
      case 2:
        if (isPolicyPlacementDoneWithTrovity === DECISION_ENUMS.YES) {
          handleStepTwoSubmission();
        } else {
          emailReminderDetails.handleSubmit();
        }
        break;
      case 3:
        handleStepThreeSubmission();
        break;
      case 4:
        formPolicyDocumentDetails.handleSubmit();
        break;
      case 5:
        if (isPolicyPremiumPaidInInstallments === DECISION_ENUMS.YES) {
          handleStepFiveSubmission();
        } else {
          emailReminderDetails.handleSubmit();
        }
        break;
      case 6:
        if (isPolicyPremiumPaidInInstallments === DECISION_ENUMS.YES) {
          emailReminderDetails.handleSubmit();
        }
        break;
      default:
        break;
    }
  };

  const handlePrefillData = async (data) => {
    const formOneData = {
      isPolicyPlacementDoneWithTrovity:
        data?.prePolicyPlacementData?.isPolicyPlacementDoneWithUs || "",
      whoIsTheIntermediary:
        data?.prePolicyPlacementData?.whoIsTheIntermediary || "",
      reasonForTheNonMaterializationOfTheProposal:
        data?.prePolicyPlacementData
          ?.reasonForTheNonMaterializationOfTheProposal || "",
      policyStartDate: data?.prePolicyPlacementData?.policyStartDate || null,
      policyEndDate: data?.prePolicyPlacementData?.policyEndDate || null,
      leadInsurer: data?.prePolicyPlacementData?.leadInsurer || "",
      insurerBranch: data?.prePolicyPlacementData?.insurerBranch || "",
      netPremiumPaid: data?.prePolicyPlacementData?.netPremiumPaid || null,
      grossPremium: data?.prePolicyPlacementData?.grossPremium || null,
      paymentMode: data?.prePolicyPlacementData?.paymentMode || "",
      paymentReferenceNumber:
        data?.prePolicyPlacementData?.paymentReferenceNumber || "",
      paymentDate: data?.prePolicyPlacementData?.paymentDate || null,
      financierName: data?.prePolicyPlacementData?.financierName || "",
      gstNumber: data?.prePolicyPlacementData?.gstNumber || "",
    };

    formOne.setValues(formOneData || formOne.initialValues);

    setValidation(data?.prePolicyPlacementData?.validation);

    setBrokingCompanyDetails(data?.brokingCompanyDetails);
    setPremiumBreakUpDetails(
      data?.premiumBreakUpDetails || premiumBreakUpDetails
    );
    setCommissionDetails(data?.commissionInfoDetails || commissionDetails);
    formPolicyDocumentDetails.setValues(
      data?.policyDocumentDetails || formPolicyDocumentDetails.initialValues
    );
    emailReminderDetails.setValues(
      data.notificationSettings || emailReminderDetails.initialValues
    );
    setInstallmentDetails(data?.installmentDetails || installmentDetails);
    setEndorsementPremium(data?.endorsementPremium || endorsementPremium);
    setEndorsementCommission(
      data?.endorsementCommission || endorsementCommission
    );
  };

  const getInsuranceCompanies = async () => {
    const response = await fetchRuntimeFormData(
      INSURANCE_COMPANIES_FORM_ID,
      0,
      GET_RECORDS_LIMIT
    );

    const filteredCompanies = response?.data?.content?.map((item) => {
      return item?.formData;
    });

    setInsuranceProviders(filteredCompanies || []);
  };

  const handleFilterSelectedInsuranceProviders = () => {
    const selectedProviders = insuranceProviders?.filter((item) => {
      // Iterate over each object in premiumData array
      return proposalDataRedux?.formData?.underwriterDetails?.premiumData?.some(
        (premiumItem) => {
          // Check if insuranceProvider matches the companyId of the current item
          return premiumItem?.insuranceProvider === item?.companyId;
        }
      );
    });

    return selectedProviders;
  };

  const handleNextStep = () => {
    if (btnClicked?.action === Btn_Action.NEXT) {
      setActiveStep((prevSate) => prevSate + 1);
    }
  };

  const handlePreviousStep = () => {
    setActiveStep((prevSate) => prevSate - 1);
  };

  const getInsuranceProviderObject = (companyId) => {
    const defaultProvider = {
      companyId: "",
      insuranceCategory: "",
      insuranceCompanyName: "",
    };

    return (
      insuranceProviders?.find((item) => item.companyId === companyId) ||
      defaultProvider
    );
  };

  const handleLeadInsurerChange = async (newValue) => {
    // Update leadInsurer field value
    await formOne.setFieldValue("leadInsurer", newValue?.companyId, true);

    // Find the premium data for the selected insurance provider
    const filteredPremium =
      proposalDataRedux?.formData?.underwriterDetails?.premiumData?.find(
        (item) => item?.insuranceProvider === newValue?.companyId
      );

    // Update netPremiumPaid field value based on filtered premium
    const netPremiumPaidValue = filteredPremium?.premiumBeforeTax || 0;
    const grossPremiumPaidValue = filteredPremium?.premiumAfterTax || 0;
    await formOne.setFieldValue("netPremiumPaid", netPremiumPaidValue, true);
    await formOne.setFieldValue("grossPremium", grossPremiumPaidValue, true);
  };

  const handleStartDateChange = async (newValue) => {
    await formOne.setFieldValue("policyStartDate", newValue, true);
    const endDate: any = newValue ? new Date(newValue) : null;
    endDate.setFullYear(endDate.getFullYear() + 1);
    endDate.setDate(endDate.getDate() - 1);
    await formOne.setFieldValue("policyEndDate", endDate, true);
  };

  const handleSaveNextAction = async (action) => {
    await setBtnClicked((prev) => ({ action: action, count: prev.count + 1 }));
  };

  const handleRefreshAction = async (id, formId) => {
    setIsloading(true);
    const response = await filterRuntimeFormDataWithId(formId, id);

    if (response?.success) {
      dispatch(
        setProposalData({
          id: id,
          formId: formId,
          formData: response?.data[0]?.formData,
        })
      );

      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );
      setIsloading(false);
    } else {
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );
      setIsloading(false);
    }
  };

  useEffect(() => {
    if (btnClicked.count !== 0) {
      handleStepsSubmission();
    }
  }, [btnClicked]);

  useEffect(() => {
    setCommissionDetails((prevData) => ({
      ...prevData,
      netPremium: {
        ...prevData?.netPremium,
        netPremium: premiumBreakUpDetails?.netPremium?.netPremium,
        commissionAmount:
          (premiumBreakUpDetails?.netPremium?.netPremium *
            prevData?.netPremium?.commission) /
          100,
        rewardAmount:
          (premiumBreakUpDetails?.netPremium?.netPremium *
            prevData?.netPremium?.reward) /
          100,
      },
      motorTpPremium: {
        ...prevData?.motorTpPremium,
        netPremium: premiumBreakUpDetails?.motorTpPremium?.netPremium,
        commissionAmount:
          (premiumBreakUpDetails?.motorTpPremium?.netPremium *
            prevData?.motorTpPremium?.commission) /
          100,
        rewardAmount:
          (premiumBreakUpDetails?.motorTpPremium?.netPremium *
            prevData?.motorTpPremium?.reward) /
          100,
      },
      totalPremium: {
        ...prevData.totalPremium,
        totalNetPremium:
          premiumBreakUpDetails?.netPremium?.netPremium +
          premiumBreakUpDetails?.motorTpPremium?.netPremium,
      },
    }));
  }, [
    premiumBreakUpDetails?.netPremium?.netPremium,
    premiumBreakUpDetails?.motorTpPremium?.netPremium,
  ]);

  useEffect(() => {
    if (!proposalDataRedux?.formId) {
      navigate(`${process.env.PUBLIC_URL}/proposalList`);
    }
    handlePrefillData(
      proposalDataRedux?.formData?.policyManagementAndCustomerCare
    );
    getInsuranceCompanies();
  }, [proposalDataRedux]);

  return (
    <div className={classes.PrePolicyPlacementContainer}>
      <ConfirmationDialog
        open={confirmDialogOpen}
        setOpen={setConfirmDialogOpen}
        title={CONFIRMATION_TITLE}
        content={CONFIRMATION_CONTENT}
        handleYes={handleYes}
        handleNo={handleNo}
      />
      <Dialog
        onClose={handleClosePreview}
        aria-labelledby="customized-dialog-preview"
        open={openPreview}
        className={classes.customDialog}
        fullWidth
      >
        <DialogTitle
          className={classes.previewDialogHeading}
          id="customized-dialog-preview"
        >
          {preview === PREVIEW_PLACEMENT_ENUMS.PREVIEW_PLACEMENT_LETTER
            ? "Placement letter"
            : "Placement Slip"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClosePreview}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {preview === PREVIEW_PLACEMENT_ENUMS.PREVIEW_PLACEMENT_SLIP ? (
            <PlacementSlipPreview
              placementSlipContentRef={placementSlipContentRef}
              formOne={formOne}
            />
          ) : (
            <PlacementLetterPreview
              placementLetterContentRef={placementLetterContentRef}
              formOne={formOne}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            color="primary"
            variant="outlined"
            className={classes.commonBtnStylesPolicy}
            onClick={handlePreviewDownload}
            disabled={disableDownload}
          >
            Download
          </Button>

          {/* {preview === PREVIEW_PLACEMENT_ENUMS.PREVIEW_PLACEMENT_LETTER ? (
            <Button
              color="primary"
              variant="outlined"
              className={classes.commonBtnStylesPolicy}
              onClick={() => {}}
            >
              Placement Letter Email
            </Button>
          ) : (
            <Button
              color="primary"
              variant="outlined"
              className={classes.commonBtnStylesPolicy}
              onClick={() => {}}
            >
              Placement Slip Email
            </Button>
          )} */}
        </DialogActions>
      </Dialog>

      <div className={classes.PrePolicyPlacementSection}>
        {isLoading && (
          <div className={classes.policyLoader}>
            <Lottie
              animationData={DataLoader}
              loop={true}
              style={policyAnimation}
            />
            {/* <CircularProgress size={80} />
          ...Please Wait */}
          </div>
        )}
        {activeStep === 1 && !isLoading && (
          <>
            <div className={classes.PrePolicyPlacementHeadingSection}>
              <div className={classes.PrePolicyPlacementHeading}>
                Policy Placement Data
              </div>
            </div>

            <div
              className={`${classes.formFieldsFlexRow} ${
                validation ? classes.validationAction : ""
              }`}
            >
              <div className={classes.formFieldFlexColumn}>
                <label>Is Policy Placement done with Us?</label>

                <Select
                  className={classes.selectField}
                  fullWidth
                  disabled
                  size="small"
                  value={formOne.values.isPolicyPlacementDoneWithTrovity}
                  onChange={(e) =>
                    formOne.setFieldValue(
                      "isPolicyPlacementDoneWithTrovity",
                      e.target.value,
                      true
                    )
                  }
                  error={
                    formOne.touched.isPolicyPlacementDoneWithTrovity &&
                    Boolean(formOne.errors.isPolicyPlacementDoneWithTrovity)
                  }
                >
                  {DECISION_MENUITEMS.map((item) => {
                    return <MenuItem value={item.value}>{item.title}</MenuItem>;
                  })}
                </Select>
                <FormHelperText className="formikFieldsErrorColor">
                  {formOne.touched.isPolicyPlacementDoneWithTrovity &&
                    formOne.errors.isPolicyPlacementDoneWithTrovity}
                </FormHelperText>
              </div>

              {formOne.values.isPolicyPlacementDoneWithTrovity ===
                DECISION_ENUMS.NO && (
                <div className={classes.formFieldFlexColumn}>
                  <label>Who is the intermediary?</label>

                  <TextField
                    fullWidth
                    size="small"
                    name="whoIsTheIntermediary"
                    value={formOne.values.whoIsTheIntermediary}
                    onChange={formOne.handleChange}
                    helperText={
                      formOne.touched.whoIsTheIntermediary &&
                      formOne.errors.whoIsTheIntermediary
                    }
                    error={
                      formOne.touched.whoIsTheIntermediary &&
                      Boolean(formOne.errors.whoIsTheIntermediary)
                    }
                    InputProps={{
                      className: classes.textField,
                    }}
                  />
                </div>
              )}

              {formOne.values.isPolicyPlacementDoneWithTrovity ===
                DECISION_ENUMS.NO && (
                <div className={classes.formFieldFlexColumn}>
                  <label>
                    Reason for the non-materialization of the proposal
                  </label>

                  <FormControl>
                    <Autocomplete
                      size="small"
                      fullWidth
                      disableClearable
                      id="reasonForTheNonMaterializationOfTheProposal-autocomplete"
                      options={nonMaterializationReasonsList}
                      value={
                        formOne.values
                          .reasonForTheNonMaterializationOfTheProposal
                      }
                      onChange={(_, newValue) =>
                        formOne.setFieldValue(
                          "reasonForTheNonMaterializationOfTheProposal",
                          newValue,
                          true
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          helperText={
                            formOne.touched
                              .reasonForTheNonMaterializationOfTheProposal &&
                            formOne.errors
                              .reasonForTheNonMaterializationOfTheProposal
                          }
                          error={
                            formOne.touched
                              .reasonForTheNonMaterializationOfTheProposal &&
                            Boolean(
                              formOne.errors
                                .reasonForTheNonMaterializationOfTheProposal
                            )
                          }
                          inputProps={{
                            ...params.inputProps,
                            className: classes.autocompleteInputStyle,
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <MenuItem {...props} value={option}>
                          {option}
                        </MenuItem>
                      )}
                    />
                  </FormControl>
                </div>
              )}

              <div className={classes.formFieldFlexColumn}>
                <label>Confirm, Policy Start Date</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    inputFormat="DD/MM/YYYY"
                    value={formOne.values.policyStartDate}
                    onChange={(newValue) => {
                      handleStartDateChange(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        inputProps={{
                          ...params.inputProps,
                          placeholder: "DD/MM/YYYY",
                          style: Date_Feild_Style,
                        }}
                        size="small"
                        helperText={
                          formOne.touched.policyStartDate &&
                          formOne.errors.policyStartDate
                        }
                        error={
                          formOne.touched.policyStartDate &&
                          Boolean(formOne.errors.policyStartDate)
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
              <div className={classes.formFieldFlexColumn}>
                <label>Policy End Date</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    inputFormat="DD/MM/YYYY"
                    value={formOne.values.policyEndDate}
                    onChange={(newValue) => {
                      formOne.setFieldValue("policyEndDate", newValue, true);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        inputProps={{
                          ...params.inputProps,
                          placeholder: "DD/MM/YYYY",
                          style: Date_Feild_Style,
                        }}
                        size="small"
                        helperText={
                          formOne.touched.policyEndDate &&
                          formOne.errors.policyEndDate
                        }
                        error={
                          formOne.touched.policyEndDate &&
                          Boolean(formOne.errors.policyEndDate)
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
              <div className={classes.formFieldFlexColumn}>
                <label>Insurer / Lead Insurer</label>
                <FormControl>
                  <Autocomplete
                    fullWidth
                    disableClearable
                    id="insurance-providers-autocomplete"
                    options={handleFilterSelectedInsuranceProviders()}
                    getOptionLabel={(option: any) => option.companyId || ""}
                    groupBy={(option: any) => option.insuranceCategory}
                    value={getInsuranceProviderObject(
                      formOne.values.leadInsurer
                    )}
                    onChange={(_, newValue) =>
                      handleLeadInsurerChange(newValue)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className={classes.fieldsMinWidth}
                        size="small"
                        helperText={
                          formOne?.touched?.leadInsurer &&
                          formOne?.errors?.leadInsurer
                        }
                        error={
                          formOne?.touched?.leadInsurer &&
                          Boolean(formOne?.errors?.leadInsurer)
                        }
                        inputProps={{
                          ...params.inputProps,
                          className: classes.autocompleteInputStyle,
                        }}
                      />
                    )}
                    renderGroup={(params) => (
                      <li key={params.key}>
                        <GroupHeader>{params.group}</GroupHeader>
                        <GroupItems>{params.children}</GroupItems>
                      </li>
                    )}
                  />
                </FormControl>
              </div>
              <div className={classes.formFieldFlexColumn}>
                <label>Insurer Branch</label>

                <TextField
                  className={classes.textField}
                  fullWidth
                  size="small"
                  name="insurerBranch"
                  value={formOne.values.insurerBranch}
                  onChange={formOne.handleChange}
                  helperText={
                    formOne.touched.insurerBranch &&
                    formOne.errors.insurerBranch
                  }
                  error={
                    formOne.touched.insurerBranch &&
                    Boolean(formOne.errors.insurerBranch)
                  }
                  InputProps={{
                    className: classes.textField,
                  }}
                />
              </div>
              <div className={classes.formFieldFlexColumn}>
                <label>Net Premium Paid excl. in Rs.</label>

                <TextField
                  className={classes.textField}
                  fullWidth
                  type="number"
                  size="small"
                  name="netPremiumPaid"
                  value={formOne.values.netPremiumPaid}
                  onChange={formOne.handleChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">₹</InputAdornment>
                    ),
                    className: classes.textField,
                  }}
                  helperText={
                    formOne.touched.netPremiumPaid &&
                    formOne.errors.netPremiumPaid
                  }
                  error={
                    formOne.touched.netPremiumPaid &&
                    Boolean(formOne.errors.netPremiumPaid)
                  }
                />
              </div>
              <div className={classes.formFieldFlexColumn}>
                <label>Gross Premium</label>

                <TextField
                  fullWidth
                  type="number"
                  size="small"
                  name="grossPremium"
                  value={formOne.values.grossPremium}
                  onChange={formOne.handleChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">₹</InputAdornment>
                    ),
                    className: classes.textField,
                  }}
                  helperText={
                    formOne.touched.grossPremium && formOne.errors.grossPremium
                  }
                  error={
                    formOne.touched.grossPremium &&
                    Boolean(formOne.errors.grossPremium)
                  }
                />
              </div>

              {formOne.values.isPolicyPlacementDoneWithTrovity ===
                DECISION_ENUMS.YES && (
                <div className={classes.formFieldFlexColumn}>
                  <label>Mode Of Payment</label>

                  <FormControl>
                    <Autocomplete
                      fullWidth
                      disableClearable
                      id="paymentMode-autocomplete"
                      options={paymentModeList}
                      value={formOne.values.paymentMode}
                      onChange={(_, newValue) =>
                        formOne.setFieldValue("paymentMode", newValue, true)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          helperText={
                            formOne.touched.paymentMode &&
                            formOne.errors.paymentMode
                          }
                          error={
                            formOne.touched.paymentMode &&
                            Boolean(formOne.errors.paymentMode)
                          }
                          inputProps={{
                            ...params.inputProps,
                            className: classes.autocompleteInputStyle,
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <MenuItem {...props} value={option}>
                          {option}
                        </MenuItem>
                      )}
                    />
                  </FormControl>
                </div>
              )}
              {formOne.values.isPolicyPlacementDoneWithTrovity ===
                DECISION_ENUMS.YES && (
                <div className={classes.formFieldFlexColumn}>
                  <label>Payment Reference Number</label>

                  <TextField
                    fullWidth
                    size="small"
                    name="paymentReferenceNumber"
                    value={formOne.values.paymentReferenceNumber}
                    onChange={formOne.handleChange}
                    helperText={
                      formOne.touched.paymentReferenceNumber &&
                      formOne.errors.paymentReferenceNumber
                    }
                    error={
                      formOne.touched.paymentReferenceNumber &&
                      Boolean(formOne.errors.paymentReferenceNumber)
                    }
                    InputProps={{
                      className: classes.textField,
                    }}
                  />
                </div>
              )}
              {formOne.values.isPolicyPlacementDoneWithTrovity ===
                DECISION_ENUMS.YES && (
                <div className={classes.formFieldFlexColumn}>
                  <label>Payment Date</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      inputFormat="DD/MM/YYYY"
                      value={formOne.values.paymentDate}
                      onChange={(newValue) => {
                        formOne.setFieldValue("paymentDate", newValue, true);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "DD/MM/YYYY",
                            style: Date_Feild_Style,
                          }}
                          size="small"
                          helperText={
                            formOne.touched.paymentDate &&
                            formOne.errors.paymentDate
                          }
                          error={
                            formOne.touched.paymentDate &&
                            Boolean(formOne.errors.paymentDate)
                          }
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>
              )}

              {formOne.values.isPolicyPlacementDoneWithTrovity ===
                DECISION_ENUMS.YES && (
                <div className={classes.formFieldFlexColumn}>
                  <label>Financier Name if any</label>

                  <TextField
                    fullWidth
                    size="small"
                    name="financierName"
                    value={formOne.values.financierName}
                    onChange={formOne.handleChange}
                    helperText={
                      formOne.touched.financierName &&
                      formOne.errors.financierName
                    }
                    error={
                      formOne.touched.financierName &&
                      Boolean(formOne.errors.financierName)
                    }
                    InputProps={{
                      className: classes.textField,
                    }}
                  />
                </div>
              )}
              <div className={classes.formFieldFlexColumn}>
                <label>GST Number</label>

                <TextField
                  fullWidth
                  size="small"
                  name="gstNumber"
                  value={formOne.values.gstNumber}
                  onChange={formOne.handleChange}
                  helperText={
                    formOne.touched.gstNumber && formOne.errors.gstNumber
                  }
                  error={
                    formOne.touched.gstNumber &&
                    Boolean(formOne.errors.gstNumber)
                  }
                  InputProps={{
                    className: classes.textField,
                  }}
                />
              </div>
            </div>

            <div className={classes.placementContainer}>
              <Button
                className={classes.commonBtnStylesPolicy}
                variant="outlined"
                color="primary"
                disabled={validation}
                onClick={() => setConfirmDialogOpen(true)}
                size="small"
              >
                Validation
              </Button>

              {/* {formOne.values.isPolicyPlacementDoneWithTrovity ===
                DECISION_ENUMS.NO && (
                <Button
                  className={classes.commonBtnStylesPolicy}
                  variant="outlined"
                  color="primary"
                  startIcon={<AutorenewIcon className={classes.btnIconStyle} />}
                  onClick={() =>
                    handleRefreshAction(
                      proposalDataRedux?.id,
                      proposalDataRedux?.formId
                    )
                  }
                  size="small"
                >
                  Refresh
                </Button>
              )} */}
              {formOne.values.isPolicyPlacementDoneWithTrovity ===
                DECISION_ENUMS.YES && (
                <>
                  <Button
                    size="small"
                    color="primary"
                    variant="contained"
                    onClick={() =>
                      handlePreviewButtonClick(
                        PREVIEW_PLACEMENT_ENUMS.PREVIEW_PLACEMENT_LETTER
                      )
                    }
                  >
                    GENERATE PLACEMENT LETTER
                  </Button>
                  <Button
                    size="small"
                    color="primary"
                    variant="contained"
                    onClick={() =>
                      handlePreviewButtonClick(
                        PREVIEW_PLACEMENT_ENUMS.PREVIEW_PLACEMENT_SLIP
                      )
                    }
                  >
                    GENERATE PLACEMENT SLIP
                  </Button>
                </>
              )}

              {userGroup === USER_GROUPS.ADMIN && (
                <Button
                  className={classes.commonBtnStylesPolicy}
                  onClick={() => setValidation(false)}
                  variant="outlined"
                  size="small"
                  disabled={!validation}
                >
                  Revalidation
                </Button>
              )}
            </div>

            {/* {formOne?.values?.isPolicyPlacementDoneWithTrovity ===
              DECISION_ENUMS.YES && (
              <div className={classes.policyPlacementDocumentsDiv}>
                <div className={classes.policyPlacementsDocumentsSection}>
                  <div className={classes.financerField}>
                    <label>Financier Name if any</label>

                    <TextField
                      fullWidth
                      size="small"
                      name="financierName"
                      value={formOne.values.financierName}
                      onChange={formOne.handleChange}
                      helperText={
                        formOne.touched.financierName &&
                        formOne.errors.financierName
                      }
                      error={
                        formOne.touched.financierName &&
                        Boolean(formOne.errors.financierName)
                      }
                    />
                  </div>
                  <div className={classes.fileUploader}>
                    <DocumentUpload
                      formOne={formOne}
                      field="panDetails"
                      title={"PAN (In case of Corporate / Individual)"}
                    />
                  </div>
                  <div className={classes.fileUploader}>
                    <DocumentUpload
                      formOne={formOne}
                      field="aadhaarDetails"
                      title={"Aadhaar (In case of Individual)"}
                    />
                  </div>
                  <div className={classes.fileUploader}>
                    <DocumentUpload
                      formOne={formOne}
                      field="gstCertificate"
                      title={"GST Certificate (in case of Corporate)"}
                    />
                  </div>
                </div>
              </div>
            )} */}
          </>
        )}
        {formOne.values.isPolicyPlacementDoneWithTrovity ===
          DECISION_ENUMS.YES &&
        activeStep === 2 &&
        !isLoading ? (
          <div className={classes.policyDetailsSectionTwoContainer}>
            <BrokingCompanyDetails
              brokingCompanyDetails={brokingCompanyDetails}
              setBrokingCompanyDetails={setBrokingCompanyDetails}
            />
            <InsuranceCompanyDetails
              insuranceCompanyDetails={insuranceCompanyDetails}
              setInsuranceCompanyDetails={setInsuranceCompanyDetails}
              insuranceProviders={insuranceProviders}
            />
          </div>
        ) : (
          formOne.values.isPolicyPlacementDoneWithTrovity ===
            DECISION_ENUMS.NO &&
          activeStep === 2 &&
          !isLoading && (
            <div className={classes.policyDetailsSectionFourContainer}>
              <EmailReminders
                emailReminderDetails={emailReminderDetails}
                proposalDataRedux={proposalDataRedux}
                isPolicyPlacementDoneWithTrovity={
                  formOne?.values?.isPolicyPlacementDoneWithTrovity
                }
                isPolicyPremiumIsPaidInInstallments={
                  formPolicyDocumentDetails?.values
                    ?.isPolicyPremiumIsPaidInInstallments
                }
              />
            </div>
          )
        )}
        {activeStep === 3 && !isLoading && (
          <div className={classes.policyDetailsSectionThreeContainer}>
            <PremiumBreakUp
              premiumData={premiumBreakUpDetails}
              setPremiumData={setPremiumBreakUpDetails}
            />
            <CommissionInfo
              commissionDetails={commissionDetails}
              setCommissionDetails={setCommissionDetails}
            />
            <EndorsementPremium
              endorsementPremium={endorsementPremium}
              setEndorsementPremium={setEndorsementPremium}
              endorsementCommission={endorsementCommission}
              setEndorsementCommission={setEndorsementCommission}
            />
          </div>
        )}

        {activeStep === 4 && !isLoading && (
          <div className={classes.policyDetailsSectionFourContainer}>
            <PolicyDocumentDetails
              formPolicyDocumentDetails={formPolicyDocumentDetails}
            />
          </div>
        )}

        {activeStep === 5 && !isLoading && (
          <>
            {formPolicyDocumentDetails?.values
              ?.isPolicyPremiumIsPaidInInstallments === DECISION_ENUMS.NO && (
              <div className={classes.policyDetailsSectionFourContainer}>
                <EmailReminders
                  emailReminderDetails={emailReminderDetails}
                  proposalDataRedux={proposalDataRedux}
                  isPolicyPlacementDoneWithTrovity={
                    formOne?.values?.isPolicyPlacementDoneWithTrovity
                  }
                  isPolicyPremiumIsPaidInInstallments={
                    formPolicyDocumentDetails?.values
                      ?.isPolicyPremiumIsPaidInInstallments
                  }
                />
              </div>
            )}
            {formPolicyDocumentDetails?.values
              ?.isPolicyPremiumIsPaidInInstallments === DECISION_ENUMS.YES && (
              <div className={classes.policyDetailsSectionFiveContainer}>
                <InstallmentDetails
                  installmentDetails={installmentDetails}
                  setInstallmentDetails={setInstallmentDetails}
                />
              </div>
            )}
          </>
        )}

        {activeStep === 6 && !isLoading && (
          <>
            {formPolicyDocumentDetails?.values
              ?.isPolicyPremiumIsPaidInInstallments === DECISION_ENUMS.YES && (
              <div className={classes.policyDetailsSectionFourContainer}>
                <EmailReminders
                  emailReminderDetails={emailReminderDetails}
                  proposalDataRedux={proposalDataRedux}
                  isPolicyPlacementDoneWithTrovity={
                    formOne?.values?.isPolicyPlacementDoneWithTrovity
                  }
                  isPolicyPremiumIsPaidInInstallments={
                    formPolicyDocumentDetails?.values
                      ?.isPolicyPremiumIsPaidInInstallments
                  }
                />
              </div>
            )}
          </>
        )}

        {!isLoading && (
          <div className={classes.actionsContainer}>
            <Button
              className={classes.commonBtnStylesPolicy}
              variant="outlined"
              color="primary"
              onClick={handlePreviousStep}
              disabled={Boolean(activeStep === 1)}
              startIcon={<ArrowBackIosIcon className={classes.btnIconStyle} />}
              size="medium"
            >
              {activeStep === 6 ? "Go Back" : "Previous"}
            </Button>

            <div className={classes.actionsSubContainer}>
              <Button
                className={classes.commonBtnStylesPolicy}
                variant="outlined"
                color="primary"
                disabled={isLoading}
                onClick={() => handleSaveNextAction(Btn_Action.SAVE)}
                startIcon={<SaveIcon className={classes.btnIconStyle} />}
                size="medium"
              >
                Save
              </Button>

              <Button
                className={classes.commonBtnStylesPolicy}
                variant="outlined"
                color="primary"
                startIcon={<AutorenewIcon className={classes.btnIconStyle} />}
                onClick={() =>
                  handleRefreshAction(
                    proposalDataRedux?.id,
                    proposalDataRedux?.formId
                  )
                }
                size="medium"
              >
                Refresh
              </Button>

              <Button
                className={classes.commonBtnStylesPolicy}
                variant="outlined"
                color="primary"
                disabled={isLoading}
                onClick={() => handleSaveNextAction(Btn_Action.NEXT)}
                endIcon={
                  activeStep !== 6 &&
                  (activeStep !== 5 ||
                    (activeStep === 5 &&
                      formPolicyDocumentDetails?.values
                        ?.isPolicyPremiumIsPaidInInstallments ===
                        DECISION_ENUMS.YES)) &&
                  (activeStep !== 2 ||
                    (activeStep === 2 &&
                      formOne?.values?.isPolicyPlacementDoneWithTrovity ===
                        DECISION_ENUMS.YES)) && (
                    <ArrowForwardIosIcon className={classes.btnIconStyle} />
                  )
                }
                size="medium"
              >
                {activeStep === 6 ||
                (activeStep === 5 &&
                  formPolicyDocumentDetails?.values
                    ?.isPolicyPremiumIsPaidInInstallments ===
                    DECISION_ENUMS.NO) ||
                (activeStep === 2 &&
                  formOne?.values?.isPolicyPlacementDoneWithTrovity ===
                    DECISION_ENUMS.NO)
                  ? "Submit"
                  : "Next"}
              </Button>
            </div>
          </div>
        )}
        {/* {formOne.values.isPolicyPlacementDoneWithTrovity ===
          DECISION_ENUMS.NO &&
          !isLoading && (
            <div className={classes.actionsContainerNo}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleStepsSubmission}
                size="medium"
                startIcon={<CheckCircleOutlineIcon />}
              >
                Submit
              </Button>
            </div>
          )} */}
      </div>
    </div>
  );
};

export default PrePolicyPlacement;
